module.exports = __webpack_public_path__ + "static/media/register.b9845652.png";